import Vue from "vue";
import Router from "vue-router";

import Auth from "./layouts/auth";
import Home from "./layouts/home";
import NotFound from "./layouts/not-found";

import { JwtHelper } from "iga-vue-ressource/helper";

import store from "@/store";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
      children: [
        {
          component: () => import(/* webpackChunkName: "dashboard" */ "./views/dashboard/"),
          name: "dashboard",
          path: "",
        },
        {
          component: () => import(/* webpackChunkName: "dashboard" */ "./views/dashboard/"),
          name: "dashboard_result",
          path: "dashboard",
        },
      ],
      component: Home,
      path: "/",
    },
    {
      children: [
        {
          component: () => import(/* webpackChunkName: "error" */ "./views/error/"),
          name: "error",
          path: "error",
        },
        {
          path: "",
          redirect: { name: "error" },
        },
      ],
      component: Auth,
      path: "/auth",
    },
    {
      component: NotFound,
      path: "*",
    },
  ],
});

router.beforeEach((to: any, from: any, next: any) => {
  const openPage: string[] = ["/auth/error", "/dashboard"];

  if (from.path === "/dasboard" && to.path === "/") {
    return next();
  }

  if (openPage.includes(to.path)) {
    return next();
  }
  const token: string = to.query.np;
  const auth: string = "auth";
  if (!JwtHelper.isValidToken(token) || !token) {
    return next("/auth/error");
  }
  store.state[auth].token = token;
  store.state[auth].url = JwtHelper.getTokenValue(token, "url");
  next();
});

export default router;
